import {createAction, props} from '@ngrx/store';
import * as fromLocation from './locations-state';
import { LocationTypeEnum } from './locations-state';
export const UPDATING_LOCATION = '[LOCATION] updating locations';
export const UPDATED_LOCATION = '[LOCATION] updated locations';
export const LOCATIONS = '[LOCATION] current location';
export const UpdatingLocation = createAction(
  UPDATING_LOCATION,
  props<{locationType: any,locations: any}>()
);

export const UpdatedLocation = createAction(
  UPDATED_LOCATION,
  props<{locationType: any,locations: any}>()
);

export const LocationsAction = createAction(
  LOCATIONS,
  props<{location: any}>()
);
